import React from "react";
import TeamImg from "../components/images/team.png";
import SkillBar from "react-skillbars";

const skills = [
  { type: "HTML", level: 90 },
  { type: "CSS", level: 85 },
  { type: "TAILWIND", level: 85 },
  { type: "PHP", level: 80 },
  { type: "JAVASCRIPT", level: 75 },
  { type: "BOOTSTRAP", level: 75 },
  { type: "REACT", level: 70 },
  { type: "SOLIDITY", level: 70 },
  { type: "PYTHON", level: 50 },
];

const colors = {
  bar: "#047aed",
  title: {
    text: "#ccc",
    background: "#047",
  },
};
const Portfolio = () => {
  return (
    <section className="mt-[9rem] w-full pb-5" id="Portfolio">
      <div className="max-w-6xl  text-gray-400 px-4 mx-auto">
        <h1
          className="font-[200] text-[3rem] max-sm:text-[2rem] px-2 xl:text-left text-center mb-5"
          data-aos="slide-up"
          data-aos-duration="1000"
        >
          My Skills
        </h1>
        <div data-aos="fade-up" data-aos-duration="1000">
          <SkillBar
            skills={skills}
            height={"1.2rem"}
            colors={colors}
            animationThreshold={[0, 0.25, 0.5, 0.75, 1]}
          />
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
